import { formatDate } from '@angular/common';


export class Util {
    public static formatarData(data) {
        if (data === '') { return ''; }
        return formatDate(data, 'dd/MM/yyyy', 'pt-BR');
    }

    public static formatarDataComHora(data) {
        if (data === '') { return ''; }
        return formatDate(data, 'dd/MM/yyyy HH:mm:ss', 'pt-BR');
    }

    public static formatarDataComHoraEnUS(data) {
        if (data === '') { return ''; }
        return formatDate(data, 'yyyy-MM-dd HH:mm:ss', 'en-US');
    }

    public static formatarDataptBRToenUS(dataptBR: string): string {

        if (dataptBR === '' || dataptBR == null) { return ''; }
        let data = dataptBR.split('/');
        if (data.length != 3) { return ''; }
        return `${data[2]}-${data[1]}-${data[0]}`;
    }


    public static DataInicioLowerThanDataTermino(dataInicioenUS: any, dataTerminoenUS: any): boolean {


        // Compara se a data Inicio é menor que a data termino inforamdas e retorna true caso sejam

        if ((!dataInicioenUS || !dataTerminoenUS) || (dataInicioenUS == '' || dataTerminoenUS == '')) {
            return false;
        }

        if (Date.parse(dataInicioenUS) < Date.parse(dataTerminoenUS)) {
            return true;
        } else {
            return false;
        }

    }

    public static DataInicioMaiorOuIgualDataTermino(dataInicio: any, dataTermino: any): boolean {
        if ((!dataInicio || !dataTermino) || (dataInicio == '' || dataTermino == '')) {
            return false;
        }

        if (Date.parse(dataInicio) <= Date.parse(dataTermino)) {
            return true;
        } else {
            return false;
        }

    }


    public static getRegExpValidateDate(): RegExp {

        var patternValidaData = /^(((0[1-9]|[12][0-9]|3[01])([-.\/])(0[13578]|10|12)([-.\/])(\d{4}))|(([0][1-9]|[12][0-9]|30)([-.\/])(0[469]|11)([-.\/])(\d{4}))|((0[1-9]|1[0-9]|2[0-8])([-.\/])(02)([-.\/])(\d{4}))|((29)(\.|-|\/)(02)([-.\/])([02468][048]00))|((29)([-.\/])(02)([-.\/])([13579][26]00))|((29)([-.\/])(02)([-.\/])([0-9][0-9][0][48]))|((29)([-.\/])(02)([-.\/])([0-9][0-9][2468][048]))|((29)([-.\/])(02)([-.\/])([0-9][0-9][13579][26])))$/;
        return patternValidaData;
    }


    public static validaData(dataptBR: string): boolean {

        var patternValidaData = this.getRegExpValidateDate();
        return patternValidaData.test(dataptBR);
    }

    public static verificarSeEhImagem(arquivoNome: string) {
        var extensao = arquivoNome.split('.').pop();

        if (extensao === 'jpg' || extensao === 'jpeg' || extensao === 'png' || extensao === 'gif') {
            return true;
        } else {
            return false;
        }
    }

    public static getArquivoNome(OSId: number, count: number) {

        const now = new Date();
    
        now.setSeconds(now.getSeconds() + count);
    
        let arquivoNome = `os${OSId}_`;
        arquivoNome += `${now.getFullYear()}_`;
        arquivoNome += `${('00' + (now.getMonth() + 1)).substr(-2, 2)}_`;
        arquivoNome += `${('00' + now.getDate()).substr(-2, 2)}_`;
        arquivoNome += `${('00' + now.getHours()).substr(-2, 2)}_`;
        arquivoNome += `${('00' + now.getMinutes()).substr(-2, 2)}_`;
        arquivoNome += `${('00' + now.getSeconds()).substr(-2, 2)}.jpg`;
    
        return arquivoNome;
    
      }


      public static dataURLtoFile(dataurl, filename) {

        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
    
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
    
        return new File([u8arr], filename, { type: mime });
      }


}